/**
 * The words a sort direction is read in (KPR-1637, KPE-051 ruling i04): the
 * direction follows the field's TYPE, so a date reads Oldest → newest and a
 * name A → Z. `asc` is the first of the pair, `desc` the second. One place, so
 * the Sort panel's toggle, its accessible name and the trigger agree.
 *
 * A family is the pair of words: two fields of one family keep the direction a
 * person set when one replaces the other (Created → Updated stays oldest
 * first); fields of different families take the new type's natural direction.
 */

const DATES = { family: 'date', asc: 'Oldest → newest', desc: 'Newest → oldest', natural: 'desc' };
const TIMES = { family: 'time', asc: 'Earliest → latest', desc: 'Latest → earliest', natural: 'asc' };
const NUMBERS = { family: 'number', asc: '1 → 9', desc: '9 → 1', natural: 'asc' };
const COUNTS = { family: 'count', asc: 'Fewest → most', desc: 'Most → fewest', natural: 'desc' };
const YES_NO = { family: 'boolean', asc: 'No → yes', desc: 'Yes → no', natural: 'desc' };
const TEXT = { family: 'text', asc: 'A → Z', desc: 'Z → A', natural: 'asc' };

const BY_TYPE = {
	date: DATES,
	'date-time': DATES,
	time: TIMES,
	// Everything the comparator (utils/sort) reads as a number.
	number: NUMBERS,
	decimal: NUMBERS,
	integer: NUMBERS,
	rating: NUMBERS,
	measurement: NUMBERS,
	currency: NUMBERS,
	// A "Me too" count and a repeating group's entries: how many (KPR-390, KPR-683).
	confirmations: COUNTS,
	'repeating-group': COUNTS,
	boolean: YES_NO,
};

/** `{ family, asc, desc, natural }` for an element's data type; text and choice (and anything unknown) read A → Z. */
export function sortWordsFor(dataType) {
	return BY_TYPE[dataType] || TEXT;
}

/** The words for one direction ('asc' or anything else as 'desc'). */
export function directionWords(dataType, direction) {
	const words = sortWordsFor(dataType);
	return direction === 'asc' ? words.asc : words.desc;
}

/** The other direction. */
export const reverseDirection = direction => (direction === 'asc' ? 'desc' : 'asc');

/**
 * The direction a field takes when it replaces another: the old one's
 * direction while the words are the same, else the new type's natural order
 * (dates and counts newest / most first, the rest ascending).
 */
export function directionAfterSwap(fromType, toType, direction) {
	const to = sortWordsFor(toType);
	return sortWordsFor(fromType).family === to.family ? (direction === 'asc' ? 'asc' : 'desc') : to.natural;
}
